var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPenImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 4.5,
    fill: "white",
    stroke: "#343A40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9641 22.7495C12.4391 22.7495 11.9141 22.7495 11.3836 22.7495C10.8422 22.7495 10.4976 22.4161 10.4922 21.8695C10.4867 20.8257 10.4922 19.7818 10.4922 18.7324C10.4922 18.4646 10.618 18.2569 10.8039 18.0657C12.707 16.1528 14.6047 14.2345 16.5078 12.3161C17.5742 11.2395 18.6406 10.1628 19.7125 9.08612C20.1555 8.63796 20.6258 8.63796 21.0742 9.08612C22.1078 10.1191 23.1414 11.152 24.175 12.1904C24.618 12.6386 24.6234 13.1086 24.1805 13.5513C21.2219 16.508 18.2633 19.4593 15.3047 22.4215C15.0805 22.6456 14.8234 22.7658 14.5008 22.7549C13.9922 22.744 13.4781 22.7495 12.9641 22.7495ZM12.2531 20.9951C12.8437 20.9951 13.4125 20.9896 13.9758 21.0005C14.1234 21.0005 14.2273 20.9568 14.3312 20.853C16.9289 18.2515 19.5266 15.6554 22.1297 13.0594C22.1844 13.0048 22.2609 12.9665 22.3101 12.9337C21.632 12.2615 20.9976 11.6275 20.3633 10.9881C20.3687 10.9826 20.3797 10.9826 20.3633 10.9881C17.6836 13.6606 15.0094 16.3386 12.3297 19.0112C12.2914 19.0494 12.2531 19.115 12.2531 19.1642C12.2476 19.7654 12.2531 20.3666 12.2531 20.9951Z",
    fill: "#343A40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5042 26.2544C14.9339 26.2544 12.3636 26.2544 9.79328 26.2544C9.64563 26.2544 9.48703 26.2544 9.34484 26.2161C8.94016 26.1123 8.71594 25.7461 8.75422 25.2815C8.7925 24.8498 9.06594 24.5601 9.4925 24.5109C9.59641 24.5 9.69484 24.5 9.79875 24.5C14.9339 24.5 20.0636 24.5 25.1988 24.5C25.3464 24.5 25.505 24.5 25.6472 24.5383C26.0519 24.6366 26.2816 25.0028 26.2488 25.4619C26.2159 25.8991 25.9425 26.1943 25.5214 26.238C25.4066 26.2489 25.2917 26.2544 25.1714 26.2544C22.6175 26.2544 20.0581 26.2544 17.5042 26.2544Z",
    fill: "#343A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenImg);
export default __webpack_public_path__ + "static/media/edit-pen-img.91053af65734e4d49d9a2093c39fc1db.svg";
export { ForwardRef as ReactComponent };